import { UserRound } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PublicLayout";

export default function Teachers() {
  const { data } = useFetch("/teachers");
  return (
    <>
      <Seo title="Öğretmenlerimiz" description="Masal Sanat Akademi öğretmen kadrosu ve branşları." />
      <PageHero eyebrow="Öğretmenler" title="Masalı birlikte yazdığımız öğretmenler">
        Her öğrencinin hızına ve hayallerine göre ders planlayan eğitmen kadromuz.
      </PageHero>
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="teachers-grid">
        {(data || []).map((t, i) => (
          <article key={t.id} className="rise rounded-3xl border border-bej bg-white p-6 flex flex-col gap-4" style={{ animationDelay: `${i * 80}ms` }} data-testid={`teacher-card-${i}`}>
            {t.image_url ? (
              <img src={t.image_url} alt={t.name} className="w-24 h-24 rounded-full object-cover ring-4 ring-bej" />
            ) : (
              <div className="grid place-items-center w-24 h-24 rounded-full bg-bej text-navy"><UserRound className="w-10 h-10" /></div>
            )}
            <div>
              <h2 className="font-heading text-xl font-extrabold text-navy">{t.name}</h2>
              <p className="text-sm font-bold text-navy/60">{t.branch}</p>
            </div>
            <p className="text-sm text-slate-600 leading-relaxed whitespace-pre-line">{t.bio}</p>
          </article>
        ))}
      </section>
    </>
  );
}
